import {Avatar, Layout, ProgressCircle} from '@di-nxt/components';
import React, {useMemo} from 'react';
import {TeamMember} from '../../../../../services';

export type CourierAvatarProps = {
  member: TeamMember | undefined;
  allocation: number;
};

export const CourierAvatar: React.FC<CourierAvatarProps> = ({
  allocation,
  member,
}) => {
  const availability = member?.monthlyHours ?? 0;
  const percentage = useMemo(() => (100 / availability) * allocation, [
    allocation,
    availability,
  ]);

  const percentageKind = useMemo(
    () =>
      percentage < 50 ? 'Warning' : percentage > 100 ? 'Negative' : 'Positive',
    [percentage],
  );

  return (
    <Layout flex centered>
      <Layout paddingVertical="16" paddingHorizontal="2">
        <Layout absolute centered>
          <ProgressCircle
            size="40"
            percentageProgress={percentage}
            kind={percentageKind}
          />
        </Layout>
        <Avatar name={member?.fullname} uri={member?.avatarUrl} size="30" />
      </Layout>
    </Layout>
  );
};
